"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        parcelle: Object
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ResumeParcelle.vue
// module id = 240
// module chunks = 0